import React, { Component, useState } from "react";
import {
  ic_e_gold_img_big,
  ic_e_silver_img_big,
  ic_e_gold_text_b,
  ic_e_silver_text_b,
  ac_list01_gold,
  ac_list01_silver,
  con_img_01,
  ac_list02,
  con_img_02,
  con_img_03,
  hana_table,
} from "styles/img";
import { AreaChart, Area, ResponsiveContainer, YAxis, XAxis } from "recharts";
import * as API from "lib/apis";
import { numberWithCommas } from "../../lib/utils";
import Loader from "components/Loader";
import { CHART_COLOR } from "constants/index";

const TEXT_ICON = {
  peg: ic_e_gold_text_b,
  pes: ic_e_silver_text_b,
};

const INIT_STATE = {
  isLoading: true,
  pegTrend: [],
  pesTrend: [],
  pegPrice: 0,
  pesPrice: 0,
  pegDiffPrice: 0,
  pesDiffPrice: 0,
  pegDiffPer: 0,
  pesDiffPer: 0,
};
class HanaBuyInfo extends Component {
  constructor(props) {
    super(props);
    const urlParam = new URLSearchParams(props.location.search);
    const type = urlParam.get("type") || "peg";
    this.state = {
      ...INIT_STATE,
      type,
    };
  }

  componentDidMount() {
    this.apiCall();
  }

  apiCall = async () => {
    const newState = {
      ...INIT_STATE,
      isLoading: false,
    };

    const apiPriceTrend = await API.getPriceTrend(({ data = {} }) => {
      newState["pegTrend"] = data["peg"] || [];
      newState["pesTrend"] = data["pes"] || [];
    }, 30);

    const apiCurrentPrice = await API.getCurrentPrice(({ data = {} }) => {
      newState["pegPrice"] = data["pegPrice"] || 0;
      newState["pesPrice"] = data["pesPrice"] || 0;
      newState["pegDiffPrice"] = data["diffPegPrice"] || 0;
      newState["pesDiffPrice"] = data["diffPesPrice"] || 0;
      newState["pegDiffPer"] =
        Math.floor(
          (Math.abs(newState["pegDiffPrice"]) /
            (newState["pegPrice"] - newState["pegDiffPrice"])) *
            10000
        ) / 100;
      newState["pesDiffPer"] =
        Math.floor(
          (Math.abs(newState["pesDiffPrice"]) /
            (newState["pesPrice"] - newState["pesDiffPrice"])) *
            10000
        ) / 100;
    });

    Promise.all([apiPriceTrend, apiCurrentPrice]).then(() =>
      this.setState(newState)
    );
  };

  handleClickType = (type) => {
    return () => {
      if (type !== this.state.type) {
        this.setState({ type: "" }, () =>
          this.setState({ type }, () => this.apiCall())
        );
      }
    };
  };

  navigateBuy = () => {
    const { type } = this.state;
    this.props.history.push("/hana-buy?type=" + type);
  };

  render() {
    const { type, isLoading } = this.state;

    const chartData = this.state[type + "Trend"] || [];
    const price = this.state[type + "Price"] || 0;
    const diffPrice = this.state[type + "DiffPrice"] || 0;
    const diffPer = this.state[type + "DiffPer"] || 0;

    let opClass = "per";
    let opText = "";
    if (diffPrice > 0) {
      opClass = "per plus";
      opText = `+${numberWithCommas(diffPrice)}▲ (+${diffPer}%)`;
    } else if (diffPrice < 0) {
      opClass = "per minus";
      opText = `${numberWithCommas(diffPrice)}▼ (${diffPer}%)`;
    }

    const textIcon = TEXT_ICON[type] || "";
    const stroke = CHART_COLOR["STROKE"][type] || "";
    const gradient = CHART_COLOR["GRADIENT"][type] || "";

    return (
      <>
        {isLoading && <Loader />}
        <div className="wrap hana_wrap" style={{ padding: 0 }}>
          <div className="content">
            <div className="chart_info">
              <div className="chart_text">
                <ul>
                  <li
                    className={`gold_pro ${type === "peg" ? "active" : ""}`}
                    onClick={this.handleClickType("peg")}
                  >
                    {" "}
                    <img
                      src={ic_e_gold_img_big}
                      alt="e금 그림 아이콘"
                      className="gold_pro_img"
                    />
                  </li>
                  <li
                    className={`silver_pro ${type === "pes" ? "active" : ""}`}
                    onClick={this.handleClickType("pes")}
                  >
                    {" "}
                    <img
                      src={ic_e_silver_img_big}
                      alt="e은 그림 아이콘"
                      className="silver_pro_img"
                    />
                  </li>
                </ul>

                {!!type && (
                  <>
                    <img
                      src={textIcon}
                      alt="e금 텍스트 아이콘"
                      className="text"
                    />
                    <p className="tt1">
                      {" "}
                      <em>{numberWithCommas(price)}</em> KRW
                    </p>
                    <p className="tt2">
                      <span className={opClass}>{opText}</span>
                    </p>
                  </>
                )}
              </div>

              <div className="chart_box" style={{ backgroundColor: "white" }}>
                {!!chartData.length && (
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={chartData}>
                      <defs>
                        <linearGradient
                          id={`color${type}`}
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stopColor={gradient}
                            stopOpacity={1}
                          />
                          <stop
                            offset="100%"
                            stopColor="#FFFFFF"
                            stopOpacity={1}
                          />
                        </linearGradient>
                      </defs>
                      <XAxis
                        dataKey="date"
                        tickLine={false}
                        axisLine={false}
                        stroke={stroke}
                        tick={{ fontSize: 10 }}
                      />
                      <YAxis
                        type="number"
                        domain={["dataMin", "dataMax"]}
                        orientation="right"
                        tickLine={false}
                        axisLine={false}
                        stroke={stroke}
                        tick={{ fontSize: 10 }}
                        width={40}
                        tickFormatter={(tick) => {
                          return numberWithCommas(tick);
                        }}
                      />
                      <Area
                        type="monotone"
                        dataKey="price"
                        stroke={stroke}
                        strokeWidth={0.5}
                        fill={`url(#color${type})`}
                        animationDuration={700}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                )}
              </div>
            </div>
            {!!type && <BuyInfoAccordian type={type} />}
          </div>

          <div className="btn_area fixed MT30 apply_btn">
            <div className="bt_col1">
              <input
                type="button"
                value="매수"
                className={`${type ? "" : "none "}navy pop`}
                onClick={this.navigateBuy}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

const BuyInfoAccordian = ({ type }) => {
  const [checked, setChecked] = useState("");
  const isGold = type === "peg";

  const getCheckbox = (id) => {
    return (
      <input
        type="checkbox"
        id={id}
        name="checkbox-accordion"
        onChange={() => {
          if (checked === id) {
            setChecked("");
          } else {
            setChecked(id);
          }
        }}
        checked={checked === id}
      />
    );
  };
  return (
    <div>
      <div className="accordion vertical">
        <ul>
          {isGold ? (
            <>
              <li>
                <div className="btn_cx_down" />
                {getCheckbox("checkbox-1")}
                <label htmlFor="checkbox-1">
                  <img src={ac_list01_gold} alt="icon" />
                  e금 이란?
                </label>
                <div className="content">
                  <div className="btn_cx_up" />
                  <h3 className="dis_none">e금이란?</h3>
                  <p className="TXC top_box">
                    <img src={con_img_01} className="con" alt="icon" />
                    <br />
                    e금의 정식 명칭은 <br />
                    <em>금교환 모바일 상품권</em>입니다.{" "}
                  </p>

                  <div className="parti" />
                  <p className="TXC mb25">
                    e금을 매수하는 것은 금교환 모바일 상품권의
                    <br />
                    소유권을 취득하는 행위를 뜻합니다.
                    <br />
                    <br />
                    매수한 e금은 실물 금으로 보관됩니다.
                    <br />
                    보유한 e금은 <em>실물 금으로 인출</em> 가능합니다.
                    <br />
                    <span className="gray">
                      (단, 비단 서비스 이용 정책에 따름)
                    </span>
                    <br />
                    <br />
                    매수･매도 시<br />
                    현금 영수증이 발행 되지 않습니다.
                    <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="btn_cx_down"></div>
                {getCheckbox("checkbox-2")}
                <label htmlFor="checkbox-2">
                  <img src={ac_list02} alt="icon" />
                  특징
                </label>
                <div className="content">
                  <h3 className="dis_none">특징</h3>
                  <div className="btn_cx_up" />
                  <p className="TXC top_box">
                    <img src={con_img_02} className="con" alt="icon" />
                    <br />
                    e금은 최소 <em>0.0001g</em> 단위로 매수할 수 있습니다.
                    <br />
                    매수･매도는 <em>24시간</em> 가능합니다.
                    <br />
                    <span className="red">
                      (단, 주말 및 공휴일은 거래 불가)
                    </span>
                    <br />
                    매도는 <em>비단 앱</em>에서 이용 가능합니다.
                  </p>

                  <div className="parti" />
                  <p className="TXC mb25">
                    시세는 국제시세, 국내외 시장동향을 참고해
                    <br />
                    <em>㈜비단골드</em>가 책정합니다.
                    <br />
                    <br />
                    e금은 호가주문이 아닌 시세에 따른
                    <br />
                    <em>매수･매도 주문체결 방식</em>으로 거래됩니다.
                    <br />
                    <br />
                    실물 금은 ㈜비단골드의
                    <br />
                    지정된 보안구역에 보관합니다.
                  </p>
                </div>
              </li>
            </>
          ) : (
            <>
              <li>
                <div className="btn_cx_down"></div>
                {getCheckbox("checkbox-1")}
                <label htmlFor="checkbox-1">
                  <img src={ac_list01_silver} alt="icon" />
                  e은 이란?
                </label>
                <div className="content">
                  <h3 className="dis_none">e은이란?</h3>
                  <div className="btn_cx_up" />
                  <p className="TXC top_box">
                    <img src={con_img_03} className="con" alt="icon" />
                    <br />
                    e은의 정식 명칭은 <br />
                    <em>은교환 모바일 상품권</em>입니다.{" "}
                  </p>

                  <div className="parti"></div>
                  <p className="TXC mb25">
                    e은을 매수하는 것은 은교환 모바일 상품권의
                    <br />
                    소유권을 취득하는 행위를 뜻합니다.
                    <br />
                    <br />
                    매수한 e은은 실물 은으로 보관됩니다.
                    <br />
                    보유한 e은은 <em>실물 은으로 인출</em> 가능합니다.
                    <br />
                    <span className="gray">
                      (단, 비단 서비스 이용 정책에 따름)
                    </span>
                    <br />
                    <br />
                    매수･매도 시<br />
                    현금 영수증이 발행 되지 않습니다.
                    <br />
                    <br />
                  </p>
                </div>
              </li>
              <li>
                <div className="btn_cx_down"></div>
                {getCheckbox("checkbox-2")}
                <label htmlFor="checkbox-2">
                  <img src={ac_list02} alt="icon" />
                  특징
                </label>
                <div className="content">
                  <h3 className="dis_none">특징</h3>
                  <div className="btn_cx_up" />
                  <p className="TXC top_box">
                    <img src={con_img_02} className="con" alt="icon" />
                    <br />
                    e은은 최소 <em>0.01g</em> 단위로 매수할 수 있습니다.
                    <br />
                    매수･매도는 <em>24시간</em> 가능합니다.
                    <br />
                    <span className="red">
                      (단, 주말 및 공휴일은 거래 불가)
                    </span>
                    <br />
                    매도는 <em>비단 앱</em>에서 이용 가능합니다.
                  </p>

                  <div className="parti" />
                  <p className="TXC mb25">
                    시세는 국제시세, 국내외 시장동향을 참고해
                    <br />
                    <em>㈜비단골드</em>가 책정합니다.
                    <br />
                    <br />
                    e은은 호가주문이 아닌 시세에 따른
                    <br />
                    <em>매수･매도 주문체결 방식</em>으로 거래됩니다.
                    <br />
                    <br />
                    실물 금은 ㈜비단골드의
                    <br />
                    지정된 보안구역에 보관합니다.
                  </p>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>

      <div className="accordion2 vertical2">
        <ul>
          <li>
            <div className="btn_cx_down" />
            {getCheckbox("checkbox-3")}
            <label htmlFor="checkbox-3">약관보기</label>
            <div className="content">
              <div className="btn_cx_up" />
              <h3 className="top_box">
                <br />
                상품권 약관
              </h3>
              <p className="TXR">
                제정일 : 2019.11.29
                <br />
                개정일 : 2020.04.17
                <br />
                개정일 : 2020.10.01
                <br />
                개정일 : 2021.02.20
                <br />
                개정일 : 2021.09.01
                <br />
                개정일 : 2022.03.01
                <br />
                개정일 : 2023.05.15
                <br />
                개정일 : 2023.09.15
                <br />
                개정일 : 2025.02.19
                <br />
                개정일 : 2025.08.01
                <br />
                개정일 : 2026.05.01
                <br />
                개정일 : 2026.06.22
              </p>
              <p>
                제1조 [목적] <br />
                이 약관은 실물과 교환이 가능한 상품교환권(이하 '상품권'이라
                함)의 발행과 관련해 상품권 구매자(이하 '회원'이라 함)가
                상품권을 사용함에 있어 발행사(이하 '회사'라 함)와 회원 간에
                준수해야 할 사항을 규정합니다. <br />
                <br />
                제2조 [용어의 정의] <br />
                이 약관에서 사용하는 용어는 다음과 같습니다.
                <br />
                1. "상품권"이라 함은 실물과 교환이 가능한 수량이 표시된
                증표로서 회사가 발행하고, 회원이 회사에 청구하는 경우 실물을
                제공받을 수 있습니다.
                <br />
                2. 상품권으로 교환이 가능한 실물 상품은 다음과 같으며, 회사 및
                유통사의 앱 서비스 등을 통해 공지 및 변경될 수 있습니다.
                <br />
                <br />
              </p>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  borderSpacing: "0",
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ border: "1px solid" }}>e금</td>
                    <td style={{ border: "1px solid" }}>
                      실물 금(Gold, 순도 99.99%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e은</td>
                    <td style={{ border: "1px solid" }}>
                      실물 은(Silver, 순도 99.99%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e플래티넘</td>
                    <td style={{ border: "1px solid" }}>
                      실물 백금(Platinum, 순도 99.95%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e팔라듐</td>
                    <td style={{ border: "1px solid" }}>
                      실물 팔라듐(Palladium, 순도 99.95%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e구리</td>
                    <td style={{ border: "1px solid" }}>
                      실물 구리(Copper, 순도 99.9%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e니켈</td>
                    <td style={{ border: "1px solid" }}>
                      실물 니켈(Nickel, 순도 99.9%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e주석</td>
                    <td style={{ border: "1px solid" }}>
                      실물 주석(Tin, 순도 99.9%)
                    </td>
                  </tr>
                  <tr>
                    <td style={{ border: "1px solid" }}>e커피</td>
                    <td style={{ border: "1px solid" }}>
                      실물 커피생두(브라질 세하도NY2 17/18)
                    </td>
                  </tr>
                </tbody>
              </table>
              <br />
              <p>
                3. "발행풀(issuance pool)"이라 함은 실물 또는 서비스와 교환이
                가능한 상품권을 발행할 수 있는 발행사(사업자) pool을
                말합니다.
                <br />
                4. "발행사"라 함은 상품권을 발행하는 사업자로서 상품권에
                표시된 사항의 이행에 대한 최종 책임을 지는 회사를 말합니다.
                <br />
                5. "유통사"라 함은 발행풀에 참여한 개별 회사와 상품권
                공급계약에 따라 자신의 명의와 계산으로 상품권을 회원에게
                매도하고 실물교환 등의 서비스를 제공하는 자로서 주식회사
                비단골드를 말합니다.
                <br />
                6. "환매"라 함은 회원이 상품권을 회사에 환매 청구하여 상품권
                상당액에 해당하는 원화를 지급받는 행위를 말하며, 환매 금액은
                환매 요청 시점의 상품기준가 시세(서비스 약관에 따름)를
                반영하여 산정됩니다.
                <br />
                7. "앱서비스"라 함은 상품권의 유통을 위해 유통사가 제작하여
                배포·서비스를 제공하는 모바일 앱 서비스 '비단'을 말합니다.
                <br />
                8. "상품기준가격"은 기준 시세를 의미합니다. 다만, 상품권
                공급 관련 계약에서 별도의 기준가격을 정하고 있는 경우 해당
                상품기준가격을 따릅니다.
                <br />
                9. "서비스 이용약관"이라 함은 유통사가 발행사가 발행한
                상품권을 유통하기 위해 운영하는 앱서비스의 이용약관을
                말한다.
                <br />
                <br />
                제3조 [정보제공]
                <br />
                상품권에는 다음의 중요 정보를 표시합니다.
                <br />
                1. 발행사 : 한국금거래소(e금, e은, e플래티넘, e팔라듐),
                고려비철금속(e구리, e니켈, e주석), 맥널티인터네셔널(e커피)
                <br />
                2. 구매가격(할인된 경우 할인율 및 할인금액) : 상품권 구매 시
                발행되는 구매내역서 참조
                <br />
                3. 제공물품 : 상품권 표시된 교환 대상 실물 및 그 수량(본 약관
                제2조 참조)
                <br />
                4. 유효기간 : 상품권별 개별표시(연장가능)
                <br />
                5. 사용처 : 유통사
                <br />
                6. 지급보증에 관한 사항 : 본 약관 제11조 참조
                <br />
                7. 상품권의 사용 : 본 약관 제4조 참조
                <br />
                8. 청약철회 및 환매 : 본 약관 제5조 및 제6조
                <br />
                9. 현금영수증 발행 : 상품권 구입 시 세금계산서 및
                현금영수증 발행 불가(회원이 실물을 제공받을 경우 현금영수증
                발행)
                <br />
                10. 소비자 피해 발생 시 연락할 관련 전화번호 등<br />
                <br />
                제4조 [상품권의 구입 및 사용] <br />
                1. 본 상품권은 회사가 발행하며, 유통사 및 유통사와 제휴 된
                사업자가 제공하는 서비스를 통해 구입할 수 있습니다.
                <br />
                2. 본 상품권 구입에 따른 세금계산서 및 현금영수증은 발행이
                되지 않습니다. 단, 회원이 본 상품권을 사용하면서 현금영수증
                발급을 요구하는 경우 회원이 실물을 제공받은 시점에
                사용처에서 해당 실물에 대한 현금영수증을 발급합니다.
                <br />
                3. 본 상품권을 보유하고 있는 회원은 회사에 실물교환을 청구할
                수 있으며, 유통사가 회사의 업무를 대행할 수 있습니다. 다만,
                실물교환을 청구할 수 있는 최소 수량 및 인출단위, 인출시기,
                인출방법, 인출수수료 등은 회사 또는 유통사의 운영정책에
                따릅니다.
                <br />
                4. 본 상품권을 이용하여 유통사 및 유통사와 제휴 된 사업자가
                판매하는 실물 또는 서비스로 교환을 청구할 수 있습니다.
                다만, 유통사의 운영정책을 따릅니다.
                <br />
                5. 회사, 유통사, 제휴사가 이벤트 등의 마케팅 활동으로
                회원에게 추가로 제공한 상품권 유효기간은 회사, 유통사,
                제휴사의 정책에 따라 별도로 책정될 수 있습니다.
                <br />
                <br />
                제5조 [청약철회 및 환매권]
                <br />
                1. 상품권 거래가 앱 서비스 내 회원 사이에 이루어지는 경우,
                전자상거래 등에서의 소비자보호에 관한 법률 제17조에 의한
                청약철회 또는 계약의 해제가 적용되지 아니합니다.
                <br />
                2. 회사로부터 직접 상품권을 구매한 회원은 구매일로부터 7일
                이내에 청약철회를 요청할 수 있습니다. 단, 다음 각 호의
                경우에는 청약철회가 제한됩니다.
                <br />
                ① 실물교환 신청, 타인에게 선물하기, 매도, 적립, 포인트 전환
                등의 방법으로 상품권의 전부 또는 일부를 사용한 경우, 그 사용
                부분에 대해서는 청약철회가 제한됩니다.
                <br />
                ② 국제 원자재 시세와 연동되어 실시간으로 상품권 가치가
                변동될 수 있는 특성상, 시간의 경과에 의하여 재판매가 곤란할
                정도로 상품권의 가치가 현저히 감소한 경우, 청약철회가
                제한됩니다.
                <br />
                3. 본 조 2항에 따른 청약철회 기간이 경과하거나 철회 요건을
                충족하지 못한 경우, 회원은 회사에 환매를 청구할 수 있으며,
                환매 금액은 환매 요청 시점의 상품기준가 시세(서비스
                이용약관에 따름)를 적용하여 환매 청구를 수용할 수 있습니다.
                다만, 회원의 환매와 관련한 제반 업무는 상품권 유통사가
                대행할 수 있으며, 시장환경으로 인해 불가피하게 환매 청구를
                제한적으로 수용하거나 지연될 수 있습니다.
                <br />
                4. 회원은 상품권 전부에 대해서 환매 청구를 해야 하며 구매한
                상품권의 일부에 대한 환매 청구는 인정하지 않습니다.
                <br />
                5. 본 조 제4항의 환매 시 유통사가 별도로 정한 환매수수료가
                부과되며, 환매수수료는 서비스 운영정책을 따릅니다.
                <br />
                6. 회사는 본 조의 내용을 본 약관을 통하여 공지하는 것과는
                별도로, 상품권에도 본 조의 내용의 요지를 표시합니다. 아울러
                회원은 상품권 주문 시 별도로 명시되는 상품권 구매계약의
                청약철회 등에 관한 내용과 환매권에 대한 내용을 확인하고 이에
                동의하여야 상품권을 구매할 수 있습니다.
                <br />
                <br />
                제6조 [유효기간 만료에 따른 권리 행사 및 처리]
                <br />
                1. 본 상품권의 유효기간이 만료되는 날까지, 회원은 다음 각
                호의 방법으로 권리를 행사할 수 있습니다.
                <br />
                ① 회사에 상품권을 사용하여 실물교환을 청구하는 방법
                <br />
                ② 유통사가 운영하는 서비스에서 산정한 상품기준가
                시세(서비스 이용약관에 따름)를 적용하여 환매하는 방법
                <br />
                2. 회원이 상품권의 유효기간 내에 본 조 제1항의 권리를
                행사하지 아니하고 그 유효기간이 만료되는 경우 또는 본
                상품권 발행 등과 관련하여 회사와 유통사가 체결한 상품권
                발행/유통계약서의 유효기간이 만료되는 경우, 그 만료 시점
                기준 회원이 보유한 상품권은 본 조 제1항 제2호의 방법에 따라
                자동 환매 처리됩니다.
                <br />
                <br />
                제7조 [거래 지원]
                <br />
                1. 회사는 유통사를 통하여 회원이 보유하고 있는 상품권을
                거래할 수 있도록 지원합니다.
                <br />
                2. 회사는 유통사를 통한 상품권 거래가 제한될 경우, 회사의
                유통망을 통하여 회원이 상품권을 사용할 수 있도록 지원합니다.
                <br />
                3. 유통사는 회원의 상품권 사용의 편의를 위하여 회원에게
                실물 또는 서비스를 우선적으로 제공할 수 있으며, 회사는
                유통사의 거래지원 활동을 적극 지원합니다.
                <br />
                <br />
                제8조 [분실, 도난, 위조 및 변조시의 책임]
                <br />
                ① 회원의 관리소홀로 인한 상품권의 분실 혹은 도난에 대한
                책임은 회원에게 있습니다. 다만, 회사가 회원으로부터 상품권
                분실 또는 도난 등을 통지 받은 때에는 회원의 신분이 확인될
                경우 해당 상품권의 사용을 정지 할 수 있습니다.
                <br />
                ② 회사는 상품권의 위조 또는 변조 등으로 인하여 해당 상품권의
                소유자인 회원에게 손해가 발생한 경우에는 그 손해를 배상할
                책임을 집니다. 다만, 회사가 회원의 관리소홀 등의 책임을
                입증하거나 천재지변 등 불가항력적인 사유로 인한 것임을
                입증한 경우에는 그러하지 않습니다.
                <br />
                ③ 상품권의 분실, 도난, 위조 및 변조시의 책임과 관련한 제반
                업무는 회사로부터 위탁을 받은 유통사가 대행할 수 있습니다.
                <br />
                <br />
                제9조 [회사와 유통사의 책임]
                <br />
                ① 회사는 회사가 발행한 상품권에 상응하는 실물교환 서비스를
                제공하며, 해당 서비스 제공의 문제가 발생할 경우 최종적
                책임은 회사에게 있습니다. 다만, 회원 또는 유통사의 과실이
                확인될 경우 회사는 그 책임지지 않습니다.
                <br />
                ② 유통사는 앱 서비스를 통해 회사가 발행한 상품권을
                회원에게 판매, 매매중개 및 실물교환 서비스를 제공할 수
                있으며, 해당 서비스 제공의 문제가 발생할 경우 책임은
                유통사에게 있습니다. 다만, 회원 또는 회사의 과실이 확인될
                경우 유통사는 그 책임을 지지 않습니다.
                <br />
                <br />
                제10조 [회원의 손해배상 책임] <br />① 회원이 이 약관을
                위반하거나 불법행위를 함으로써 발생하는 모든 문제는
                회원에게 책임이 있으며, 이로 인한 회사, 유통사 또는 제3자의
                손해에 대하여 회원은 손해액 전액을 배상하여야 합니다. <br />
                ② 본 조 제1항의 회원의 행위로 인하여 회사 또는 유통사가
                제3자로부터 손해배상 청구 또는 소송을 비롯한 각종
                이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로
                회사와 유통사를 면책시켜야 하며, 그로 인하여 발생한 모든
                손해를 배상하여야 합니다.
                <br />
                <br />
                제11조 [지급보증 등]
                <br />
                ① 본 상품권은 별도 지급보증 및 피해보상보험 없이 상품권
                발행사인 회사의 신용으로 발행되었습니다.
                <br />
                ② 본 상품권을 유통하는 유통사는 상품권 발행사가 가지는
                지급보증 및 피해보상 등의 책임에서 면책됩니다.
                <br />
                <br />
                제12조 [약관의 게시와 개정] <br />
                ① 이 약관의 내용은 회사의 홈페이지 또는 유통사의 앱
                서비스에 게시하거나 기타의 방법으로 이용자에게 공지함으로써
                효력이 발생합니다. <br />
                ② 회사는 필요하다고 인정되는 경우 이 약관을 개정할 수
                있으며, 약관을 개정할 경우 그 적용일자 및 내용, 개정사유
                등을 명시하여 현행 약관과 함께 적용일자 7일 전부터 본 조
                제1항과 같은 방법으로 공지합니다. 단, 회원의 권리 또는
                의무에 관한 중요한 규정을 변경하거나 회원에게 불리하게
                약관의 내용을 변경하는 경우에는 최소한 그 적용일자 15일
                이전부터 공지합니다. <br />
                <br />
                제13조 [분쟁해결]
                <br />
                이 약관과 관련하여 회사와 회원 사이에 발생한 분쟁에 관한
                소송은 민사소송법상의 관할법원에 제기합니다.
                <br />
                <br />
                제14조 [기타]
                <br />
                본 약관에 명시되지 아니한 사항 또는 약관해석상 다툼이 있는
                경우에는 회원과 회사 또는 유통사간 합의에 의하여 결정하며,
                합의가 이루어지지 아니한 경우에는 관계법령 및 일반관례에
                따릅니다.
                <br />
                <br />
                부칙 {"<"}2019.11.29{">"}
                <br />
                이 규정은 2019년 11월 29일부터 제정/시행한다.
                <br />
                부칙 {"<"}2020.04.17{">"}
                <br />
                이 규정은 2020년 04월 17일부터 시행한다.
                <br />
                부칙 {"<"}2020.10.01{">"}
                <br />
                이 규정은 2020년 10월 01일부터 시행한다.
                <br />
                부칙 {"<"}2021.02.20{">"}
                <br />
                이 규정은 2021년 02월 20일부터 시행한다.
                <br />
                부칙 {"<"}2021.09.01{">"}
                <br />
                이 규정은 2021년 09월 01일부터 시행한다.
                <br />
                부칙 {"<"}2022.03.01{">"}
                <br />
                이 규정은 2022년 03월 01일부터 시행한다.
                <br />
                부칙 {"<"}2023.05.15{">"}
                <br />
                이 규정은 2023년 05월 15일부터 시행한다.
                <br />
                부칙 {"<"}2023.09.15{">"}
                <br />
                이 규정은 2023년 09월 15일부터 시행한다.
                <br />
                부칙 {"<"}2025.02.19{">"}
                <br />
                이 규정은 2025년 02월 19일부터 시행한다.
                <br />
                부칙 {"<"}2025.08.01{">"}
                <br />
                이 규정은 2025년 08월 01일부터 시행한다.
                <br />
                부칙 {"<"}2026.05.01{">"}
                <br />
                이 규정은 2026년 05월 01일부터 시행한다.
                <br />
                부칙 {"<"}2026.06.22{">"}
                <br />
                이 규정은 2026년 06월 22일부터 시행한다.
                <br />
              </p>
            </div>
          </li>
          <li className="3t">
            <div className="btn_cx_down" />
            {getCheckbox("checkbox-4")}
            <label htmlFor="checkbox-4" className="3t">
              수수료
            </label>
            <div className="content">
              <div className="btn_cx_up" />
              <p className="top_box">
                <img src={hana_table} className="table" alt="icon" />
              </p>
              <div className="F12 TXL co9">
                (수수료에 대한 VAT는 별도 입니다.)
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default HanaBuyInfo;
